import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import createSagaMiddleware from "redux-saga"
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reducer from './reducer'
import rootSaga from './saga'


const sagaMiddleware = createSagaMiddleware();

// create redux store with history
const store = createStore(reducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();
